import { render, staticRenderFns } from "./SlideTypeList.vue?vue&type=template&id=19fa64d8&scoped=true&"
import script from "./SlideTypeList.vue?vue&type=script&lang=js&"
export * from "./SlideTypeList.vue?vue&type=script&lang=js&"
import style0 from "./SlideTypeList.vue?vue&type=style&index=0&id=19fa64d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fa64d8",
  null
  
)

export default component.exports